module.exports = __webpack_public_path__ + "img/eg7.5765f054.png";